import { Component, OnInit } from '@angular/core';
import { FacultyService } from 'src/app/service/faculty.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acadmy-instractor',
  templateUrl: './acadmy-instractor.component.html',
  styleUrls: ['./acadmy-instractor.component.css']
})
export class AcadmyInstractorComponent implements OnInit {
  facultyMainTech: any[] = []
  facultyTechGroup
  techDetails: any = {}
  constructor(private facultyService: FacultyService, private router: Router) { }

  ngOnInit(): void {

    this.facultyService.GetAllTeachingMembers().subscribe((res: any) => {
      console.log("instractors", res)
      this.facultyTechGroup = res.teachingmembersGroup
      this.facultyMainTech.push(res.academyPresident)
      this.facultyMainTech.push(res.academyVicePresident)
      res.facultyDeans.forEach(element => {
        this.facultyMainTech.push(element)
      });
    })
  }


  // Open the member's profile using the redesigned details page. The institute is
  // unknown at the academy level, so pass 0 and let that page resolve it by name.
  openProfile(id) {
    this.router.navigate(['/instractors_details', 0, id])
  }
  scroolDowen(elemnt_id) {
    document.getElementById(elemnt_id).scrollIntoView()
  }

}
